define('C3.ShoppingExtensions.HeaderMenu.MobileMyAccount.Sidebar'
, 	[
		'header_menu.tpl',
        'Profile.Model',
       // 'SC.Configuration',
        'Utils',
        'Header.Menu.MyAccount.View',
        'Header.Menu.View',
        'SCView'
	],
function (
		header_menu_tpl,
        ProfileModel,
        //Configuration,
        Utils,
        HeaderMenuMyAccountView,
        HeaderMenuView,
        SCViewModule
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function HeaderExtensionMobileMyAccountSidebar (options) {
        SCView.call(this, options);

        this.template = header_menu_tpl;
        this.options = options;
        this.application = options.application;


        this.pushMe = function pushMe(el){

            var target = el.currentTarget
            ,   parent = $(target).parent('.has-subcategories');

            var find_ul = parent.find(".subcategories").first();
            /*$(find_ul).addClass('menu-is-opened')
            if(parent.siblings().hasClass('menu-is-opened'))
             parent.siblings().removeClass('menu-is-opened')*/   
            $(find_ul).slideToggle(200);
        }

    }

    HeaderExtensionMobileMyAccountSidebar.prototype = Object.create(SCView.prototype);
    HeaderExtensionMobileMyAccountSidebar.prototype.constructor = HeaderExtensionMobileMyAccountSidebar;

    HeaderExtensionMobileMyAccountSidebar.prototype.getEvents = function() {
            return {
                'click [data-action="push-menu1"]':'pushMe'
            };
        }

    HeaderExtensionMobileMyAccountSidebar.prototype.getContext = function () {
    	var Configuration = this.application.Configuration

        var profile = ProfileModel.getInstance()
        ,   is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
        ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
        
        return {
           isLoggedIn : !is_loading && is_logged_in,
           isPhoneDevice: Utils.isPhoneDevice()
        }
    }

    return HeaderExtensionMobileMyAccountSidebar
});
